import React from 'react'
import { DotsContainer, Dot } from './styles'

interface CarouselDotsProps {
    totalImages?: number
    currentIndex?: number
}

const CarouselDots: React.FC<CarouselDotsProps> = ({ totalImages = 0, currentIndex = 0 }) => {
    const visibleDots = Math.min(5, totalImages) // Show up to 5 dots, but not more than total images
    const halfVisibleDots = Math.floor(visibleDots / 2)

    // Calculate the indices represented by the visible dots
    const offset = Math.max(0, Math.min(currentIndex - halfVisibleDots, totalImages - visibleDots))

    return (
        <DotsContainer>
            {Array.from({ length: visibleDots }, (_, idx) => {
                const actualIndex = offset + idx // Map dot to carousel image index
                const isActive = actualIndex === currentIndex
                return <Dot key={idx} isActive={isActive} />
            })}
        </DotsContainer>
    )
}

export default CarouselDots
